import numeral from "numeral";
import React from "react";
import { DropTarget } from "react-drag-drop-container";
import { FormattedMessage } from "react-intl";

const dropTargetFunction = (
  text,
  record,
  index,
  draggingFrom,
  setDroppingOn
) => {
  return (
    <DropTarget
      onDragEnter={() => {
        if (record?.conto?.uuid !== draggingFrom && record?.conto?.isPosting) {
          setDroppingOn(record.conto.uuid);
        }
      }}
      onDragLeave={() => {
        setDroppingOn(null);
      }}
      targetKey="precog-articles-drag"
      highlightClassName="precog-conto-drag-highlight"
    >
      {text || <div className="conti-contabili-empty-cell">&nbsp;</div>}
    </DropTarget>
  );
};

export const columnsContiContabili = (
  draggingFrom, setDroppingOn, regimeId, reasonId
) => {  
  return [
    {
      title: <FormattedMessage id="preCog.accountingLines.table.accountingAccount" />,
      width: "24%",
      dataIndex: "contoContabile",
      key: "contoContabile",
      render: (
        text, record, index
      ) => {        
        return dropTargetFunction(
          (<div>
            <div style={{fontWeight: 500}}>{text}</div>
            {!!record.previousBalance && 
              <div style={{fontWeight: 400, fontSize: "12px", 
                padding: "0 11px", 
                lineHeight: 0, paddingBottom: "10px"}}>              
                <FormattedMessage id="preCog.accountingLines.table.previousBalance" /> &nbsp;
                {numeral(record.previousBalance).format("0,0.00")} {record.currency}
              </div>
            }
          </div>), record, index, draggingFrom, setDroppingOn
        );
      }
    },
    {
      title: reasonId === "CO1" ? "" : <FormattedMessage id="preCog.accountingLines.table.vat" />,
      align: "left",
      headerAlign: "left",
      width: "20%",
      dataIndex: "regime",
      key: "regime",      
      render: (
        text, record, index
      ) => 
      /** Visualizzo le voci come fossero header tabella solo in caso di presenza
       * di accordion e nel caso Regime solo se il regime segnalato in header è
       * multi regime https://jira.teamsystem.com/browse/DOP-816        
      */
        dropTargetFunction(
          <div style={{color: "#5a6872", fontWeight: "normal"}}>
            {record?.conto?.hasChildren && regimeId === "MULTI" ? 
              <FormattedMessage id="preCog.accountingLines.table.regime" /> : text}
          </div>, 
          record, index, draggingFrom, setDroppingOn
        )         
    },
    {
      title: "",
      width: "6.5%",
      dataIndex: "taxable",
      key: "taxable",
      align: "left",
      headerAlign: "left",
      hidden: reasonId !== "CO1",
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          <div style={{color: "#5a6872", fontWeight: "normal"}}>
            {record?.conto?.hasChildren ? <FormattedMessage id="preCog.accountingLines.table.taxable" /> : text}</div>, record, index, draggingFrom, setDroppingOn
        )
    },
    {
      title: "",
      align: "left",
      headerAlign: "center",
      width: "8%",
      dataIndex: "aliquota",
      key: "aliquota",      
      render: (
        text, record, index
      ) =>         
        dropTargetFunction(
          <div style={{color: "#5a6872", fontWeight: "normal"}}>
            {record?.conto?.hasChildren ? <FormattedMessage id="preCog.accountingLines.table.rate" /> : text}
          </div>, record, index, draggingFrom, setDroppingOn
        )
    },
    {
      title: "",
      width: "6.5%",
      dataIndex: "tax",
      key: "tax",
      align: "left",
      headerAlign: "left",
      hidden: reasonId !== "CO1",
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          <div style={{color: "#5a6872", fontWeight: "normal"}}>
            {record?.conto?.hasChildren ? <FormattedMessage id="preCog.accountingLines.table.tax" /> : text}</div>, record, index, draggingFrom, setDroppingOn
        )
    },
    {
      title: "",
      align: "left",
      headerAlign: "center",
      width: reasonId === "CO1" ? "15%" : "10%",
      dataIndex: "destinazione",
      key: "destinazione",
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          <div style={{color: "#5a6872", fontWeight: "normal"}}>
            {record?.conto?.hasChildren ? <FormattedMessage id="preCog.accountingLines.table.destination" /> : text}</div>, record, index, draggingFrom, setDroppingOn
        )
    },
    {
      title: <FormattedMessage id="preCog.accountingLines.table.give" />,
      width: "6.5%",
      dataIndex: "dare",
      key: "dare",
      align: "left",
      headerAlign: "left",
      hidden: reasonId === "CO1",
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          text, record, index, draggingFrom, setDroppingOn
        )
    },
    {
      title: <FormattedMessage id="preCog.accountingLines.table.have" />,
      width: "6.5%",
      dataIndex: "avere",
      key: "avere",
      align: "left",
      headerAlign: "left",
      hidden: reasonId === "CO1",
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          text, record, index, draggingFrom, setDroppingOn
        )
    },             
    {
      title: <FormattedMessage id="preCog.accountingLines.table.amount" />,
      width: reasonId === "CO1" ? 150 : 250,
      dataIndex: "amountWithVat",
      key: "amountWithVat",
      align: "left",
      headerAlign: "left",
      hidden: reasonId !== "CO1",
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          text, record, index, draggingFrom, setDroppingOn
        )
    },
    {
      title: <FormattedMessage id="preCog.accountingLines.table.startEndDate" />, 
      width: 250,
      dataIndex: "inizioCompetenza",
      key: "inizioCompetenza",
      hidden: reasonId === "CO1",
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          text, record, index, draggingFrom, setDroppingOn
        )
    },
    {
      title: "",
      width: 40,
      dataIndex: "contoDetail",
      key: "contoDetail",
      align: "right",      
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          text, record, index, draggingFrom, setDroppingOn
        )
    },
    {
      title: "",
      width: 32,
      dataIndex: "removeConto",
      key: "removeConto",
      align: "right",
      render: (
        text, record, index
      ) =>
        dropTargetFunction(
          text, record, index, draggingFrom, setDroppingOn
        )
    }
  ].filter(item => !item.hidden);
};
